export default {
  shadowCRUD: true,
  endpoint: '/graphql',
  subscriptions: false,
  maxLimit: -1,
  apolloServer: {},
};
